<template>
  <div class="networkState">
    <div class="container">
      <div class="network-title" >{{lanInfo.title}}</div>
      <div class="network-status">
        <div class="network-status-item">
          <img class="imgs" src="~img/blockChain/status_yxz_dx.gif" alt />
          {{lanInfo.status1}}
        </div>
        <!-- <div class="network-status-item">
          <img class="imgs" src="~img/blockChain/status_sjz_dx.gif" alt />
          {{lanInfo.status2}}
        </div> -->
        <div class="network-status-item">
          <img class="imgs" src="~img/blockChain/status_gj_dx.gif" alt />
          {{lanInfo.status3}}
        </div>
      </div>
      <div class="network-content">
        <div
          v-for="(item ,index) in curNode"
          :key="index"
          class='network-content-tips'
          :style="{'right': item.right+'px', 'top': item.top+'px'}"   
        >
          <!-- -->
          <img :src="item.signUrl" alt />
          <div class="node-tips">
            <img :src="item.nodeUrl" alt />
          </div>
        </div>
      </div>
      <div class="network-nodes">
        <div class="network-nodes-title" style="color:#1A8DEC;">{{lanInfo.nodesTitle}}</div>
        <pub-animate @showAnimate="nodeShow=true">
          <div class="network-nodes-num" style="text-align:center;width: 70px;line-height: 65px;" v-show="nodeShow">{{curlenght}}</div>
        </pub-animate>
        <!-- 节点轮播 -->
        <div class="network-nodes-preview">
          <ul class="office-point" ref="officePoint">
            <li :style="{'width':item.show_logo_width+'px'}" v-for="(item,index) in curNode" :key="index">
              <img :src="item.show_logo" alt />
            </li>
            <template v-if="curNode.length>3">
             <li :style="{'width':item.show_logo_width+'px'}" v-for="(item,index) in curNode.slice(0,4)" >
              <img :src="item.show_logo" alt />
             </li>
            </template>
          </ul>
        </div>
        <!-- 动态效果 -->
        <ul class="network-nodes-trends">
          <li class="trends-item trends-item-1"></li>
          <li class="trends-item trends-item-2"></li>
          <li class="trends-item trends-item-3"></li>
          <li class="trends-item trends-item-4"></li>
          <li class="trends-item trends-item-5"></li>
        </ul>
        <div class="network-nodes-shade">
          <img src="~img/blockChain/dapp_sl_bg.png" alt />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      nodeShow: false,
      // wsUrl:"ws://59.110.150.162:9059",//测试
       wsUrl:"wss://www.legalxchain.com",//生产
      nodeList:[],
      curlenght:0,
      blockInfo:{},
      txList:[],
      txListF:[],
      txListG:[],
      blockInfoList:[],
      tt:null,
      lockReconnect:false,//避免重复链接        
      imgs: [
        {
          index: 0,
          // signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
          nodeUrl: require("../../assets/images/blockChain/pointPosition/bjscagzc_position_img.png"),
          name: "北京市长安公证处",
        },
        {
          index: 1,
          signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
          nodeUrl: require("../../assets/images/blockChain/pointPosition/bjsdfgzc_position_img.png"),
          name: "北京市东方公证处",
        },
        {
          index: 2,
          signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
          nodeUrl: require("../../assets/images/blockChain/pointPosition/bjsfzgzc_position_img.png"),
          name: "北京市方正公证处",
        },
        {
          index: 3,
          signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
          nodeUrl: require("../../assets/images/blockChain/pointPosition/bjsgxgzc_position_img.png"),
          name: "北京市国信公证处",
        },
        {
          index: 4,
          signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
          nodeUrl: require("../../assets/images/blockChain/pointPosition/bjhlwfy_position_img.png"),
          name: "北京互联网法院数据同步节点",
        },
        {
          index: 5,
          signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
          nodeUrl: require("../../assets/images/blockChain/pointPosition/gzhlwfy_position_img.png"),
          name: "广州互联网法院数据同步节点",
        },
        {
          index: 6,
          signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
          nodeUrl: require("../../assets/images/blockChain/pointPosition/hbxhgzc_position_img.png"),
          name: "河北省香河公证处",
        },
        {
          index: 7,
          signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
          nodeUrl: require("../../assets/images/blockChain/pointPosition/hzhlwfy_position_img.png"),
          name: "杭州互联网法院数据同步节点",
        },
        {
          index: 8,
          signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
          nodeUrl: require("../../assets/images/blockChain/pointPosition/hzhlwgzc_position_img.png"),
          name: "杭州互联网公证处",
        },
        {
          index: 9,
          signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
          nodeUrl: require("../../assets/images/blockChain/pointPosition/ip360_position_img.png"),
          name: "IP360",
        },
        {
          index: 10,
          signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
          nodeUrl: require("../../assets/images/blockChain/pointPosition/ipxchain_position_img.png"),
          name: "IPX",
        },
        {
          index: 11,
          signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
          nodeUrl: require("../../assets/images/blockChain/pointPosition/hckysfjdzx_position_img.png"),
          name: "海存科仪司法鉴定中心",
        },
        {
          index: 12,
          signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
          nodeUrl: require("../../assets/images/blockChain/pointPosition/nmgzzq_position_img.png"),
          name: "内蒙古自治区",
        },
        {
          index: 13,
          signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
          nodeUrl: require("../../assets/images/blockChain/pointPosition/zjswzshdgzc_position_img.png"),
          name: "浙江省温州市华东公证处",
        },
        {
          index: 14,
          signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
          nodeUrl: require("../../assets/images/blockChain/pointPosition/xcontract_position_img.png"),
          name: "Xcontract",
        },
        {
          index: 15,
          signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
          nodeUrl: require("../../assets/images/blockChain/pointPosition/hbczsbhgzc_position_img.png"),
          name: "河北省沧州市渤海公证处",
        },
        {
          index: 16,
          signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
          nodeUrl: require("../../assets/images/blockChain/pointPosition/gzshzgzc_position_img.png"),
          name: "广州市海珠公证处",
        },
        {
          index: 17,
          signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
          nodeUrl: require("../../assets/images/blockChain/pointPosition/legalxchain_position_img.png"),
          name: "legalXchain浏览器",
        },
        {
          index:18,
          signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
          nodeUrl: require("../../assets/images/blockChain/pointPosition/lx.png"),
          name: "蓝信",
        },{
          index:19,
          signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
          nodeUrl: require("../../assets/images/blockChain/pointPosition/bjjcgzc_tc_img.png"),
          name: "北京市精诚公证处",
        },{
          index:20,
          signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
          nodeUrl: require("../../assets/images/blockChain/pointPosition/fjfzmjgzc_tc_img.png"),
          name: "福建省福州市闽江公证处",
        },
        {
          index: 21,
          signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
          nodeUrl: require("../../assets/images/blockChain/pointPosition/fssbqzx_position_img.png"),
          name: "佛山市版权保护协会",
        },{
          index: 22,
          signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
          nodeUrl: require("../../assets/images/blockChain/pointPosition/adw_tc_img.png"),
          name: "安盾网",
        },{
          index: 23,
          signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
          nodeUrl: require("../../assets/images/blockChain/pointPosition/bjfy_img.png"),
          name: "北京市方圆公证处",
        }
         // ,{
        //   index: 24,
        //   signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
        //   nodeUrl: require("../../assets/images/blockChain/pointPosition/tianjin_position_img.png"),
        //   name: "天津市辰信公证处",
        // },
        ,
        {
          index: 25,
          signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
          nodeUrl: require("../../assets/images/blockChain/pointPosition/cdgl_position_img.png"),
          name: "四川省成都市国力公证处",
        },
        {
          index: 26,
          signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
          nodeUrl: require("../../assets/images/blockChain/pointPosition/gdsgzsgzgzc_img.png"),
          name: "广东省广州市广州公证处",
        },
        {
          index: 27,
          signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
          nodeUrl: require("../../assets/images/blockChain/pointPosition/gzgzcwlfqjd.png"),
          name: "广州公证处网络赋强节点",
        },
        {
          index: 28,
          signUrl: require("../../assets/images/blockChain/status_yxz_dx.gif"),
          nodeUrl: require("../../assets/images/blockChain/pointPosition/gzgzcsjbqjd.png"),
          name: "广州公证处数据保全节点",
        },
      ],
      curNode:[],
      nodeDatalist:[],
      webSocket:'',
    };
  },
  mounted() {
    this.getNodeList();
    // setTimeout(()=>{
      // this.webSocket.close();
      // this.webSocket.send('closes','关闭')
    // },10000)
    // this.init();
  },
  methods: {
    animate() {
      let ul = this.$refs.officePoint;
      let num = 0;
      let sumWidth=this.sum(this.curNode);
      let str=0;
      ul.style.width= sumWidth+str +'px';
      if(this.curNode.length>3){
        this.curNode.forEach((item,index)=>{
          if(index<4){
            str+=item.show_logo_width+5
            ul.style.width= sumWidth+str +'px';
          }
        })
        this.setKeyframes('marLeft',sumWidth,this.curNode.length*2)
      }
    },
     //设置动画
    setKeyframes(keyName,Xval,time){
      const keyframes = `@keyframes ${keyName}{
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(${-Xval}px);
            }
          }`;
          const style = document.createElement('style');
          style.type = 'text/css';
          // 将 keyframes样式写入style内
          style.innerHTML = keyframes;
          $('.office-point').css( 'animation', `marLeft ${time}s linear infinite`);
          // 将style样式存放到head标签
          document.getElementsByTagName('head')[0].appendChild(style);
    },
    //求和
    sum(arr) {
      return arr.reduce(function(prev, curr){
        return prev + (curr.show_logo_width+5);
      },0);
    },
    //节点连接
    initSocket() {
      let that=this;
      this.webSocket = io.connect(this.wsUrl+'?bcCode=A')    // 这里是 ws 协议，不是 http 协议
      this.webSocket.on('connect',()=>{
        // console.log('connected')
       })
       this.webSocket.on('clientFun', data =>{
        var obj=data?JSON.parse(data):''
        // console.log(obj,"socket响应的所有数据")
        if(obj.hasOwnProperty('blockInfo')){//区块链统计汇总
          that.blockInfo=obj.blockInfo;
          this.$emit('getBlockInfo',that.blockInfo);
        }
        if(obj.hasOwnProperty('nodeList')){//所有节点
          that.nodeList=obj.nodeList;
          that.curlenght=obj.nodeList.filter(item=>item.status==1).length;
        }
        if(obj.hasOwnProperty('txList')){//M链最新交易记录
          that.txList=obj.txList;
          this.$emit('gettxList',that.txList);
        }
        if(obj.hasOwnProperty('txListF')){//F链最新交易记录
          that.txListF=obj.txListF;
          this.$emit('gettxListF',that.txListF);
        }
        if(obj.hasOwnProperty('txListG')){//G链最新交易记录
          that.txListG=obj.txListG;
          this.$emit('gettxListG',that.txListG);
        }
        if(obj.hasOwnProperty('blockInfoList')){//区块链各产品系统计信息
          that.blockInfoList=obj.blockInfoList;
          this.$emit('getBlockInfoList',that.blockInfoList);
        }
        // //分门别类函数
          this.changeNode();
          this.$emit('getStatus',that.nodeList.every((item)=>item.status==1));
          this.$emit('getnodeList',that.nodeList);
      })  //监听服务端请求->客户端
      this.webSocket.on('disconnect',()=>{
          this.changeNode();
      })
  },
  //改变节点状态
  changeNode(){
    this.curNode=[];
       this.nodeDatalist.forEach((ele,inds)=>{
        if(this.nodeList.length){
          this.nodeList.forEach((item,ind)=>{
            if(ele.name==item.name){
              this.curNode.push({
                signUrl:item.status==1?require("../../assets/images/blockChain/status_yxz_dx.gif"):require("../../assets/images/blockChain/status_gj_dx.gif"),
                nodeUrl:ele.node_logo,
                status:item.status,
                right:ele.location?ele.location.split(',')[0]:0,
                top: ele.location?ele.location.split(',')[1]:0,
                show_logo:ele.show_logo,
                name:item.name,
                show_logo_width:ele.show_logo_width
              })
            }
          })
        }else{
          this.curNode.push({
            signUrl:ele.status==1?require("../../assets/images/blockChain/status_yxz_dx.gif"):require("../../assets/images/blockChain/status_gj_dx.gif"),
            nodeUrl:ele.node_logo,
            status:ele.status,
            right:ele.location?ele.location.split(',')[0]:0,
            top: ele.location?ele.location.split(',')[1]:0,
            show_logo:ele.show_logo,
            name:ele.name,
            show_logo_width:ele.show_logo_width
          })
        }
       })
      //  console.log(this.curNode)
        this.animate();
  },
 
  //获取节点信息
  getNodeList(){
    this.$ajax
    .get("/webapi/blockchainDapp/queryAllNode")
    .then(res => {
      if (res.data.code == 200) {
          this.nodeDatalist=res.data.extraData.nodeList;
          this.changeNode();
      }
      this.initSocket();
    });
  }
  },
  watch:{
    "nodeList"(){
      // console.log("dsdasdada")
       this.changeNode();
    }
  },
  destroyed() {
  
  },
  computed: {
    ...mapGetters({
      doneCount: "getLanInfo"
    }),
    lanInfo() {
      return this.doneCount.blockChain.networkState;
    }
  }
};
</script>
<style lang="scss" scoped>
// 区块链网络状态
.networkState {
  width: 100%;
 height: 885px;
  margin-top: 50px;
  background-image: url("~img/blockChain/chain_zt_bg.png");
  background-size: 100% 100%;
  .container {
    position: relative;
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    // background-image: url("~img/blockChain/map_china_img.png");
    // background-position: center 110px;
    // background-repeat: no-repeat;
    .network {
      &-title {
       
        background-image: url("~img/blockChain/title_bg_img.png");
            position: absolute;
    left: 50%;
    top: 39px;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    width: 585px;
    height: 40px;
    line-height: 22px;
    text-align: center;
    font-size: 26px;
    background-size: 100% 100%;
    color: #fff;
      }
      &-status {
        position: absolute;
        display: flex;
        top: 64px;
        right: 0;
        &-item {
          margin-left: 20px;
          color: #fff;
          .imgs {
            height: 20px;
            width: 20px;
            margin-right: 4px;
            vertical-align: middle;
          }
        }
      }
      &-content {
        position: absolute;
        top: 116px;
        left: 260px;
        width: 742px;
        height: 549px;
        background-image: url("~img/blockChain/map_china_img.png");
        background-repeat: no-repeat;
        background-size:100% 100%;
        &-tips {
          position: absolute;
          width: 20px;
          height: 20px;
          cursor: pointer;
          .node-tips {
            position: absolute;
            bottom: 0;
            left: 20px;
            display: none;
            width: 263px;
            height: 69px;
            pointer-events: none;
            z-index: 9;
          }
          &:hover {
            .node-tips {
              display: block;
            }
          }
          &:nth-child(3n) {
            & > img {
              animation: shown 4s ease infinite;
            }
          }
          &:nth-child(3n-1) {
            & > img {
              animation: shown 4s ease 1s infinite;
            }
          }
          &:nth-child(3n-2) {
            & > img {
              animation: shown 4s ease 2s infinite;
            }
          }
        }
      }
      &-nodes {
        position: absolute;
        left: 0;
        bottom: 54px;
        width: 100%;
        height: 164px;
        &-title {
          position: absolute;
          top: 8px;
          left: 526px;
          width: 210px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          font-size: 18px;
          color: #fff;
        }
        &-num {
          position: absolute;
          top: 52px;
          left: 44px;
          color: #fff;
          font-size: 56px;
        }
        &-preview {
          position: absolute;
          top: 66px;
          left: 175px;
          overflow: hidden;
          width: 695px;
          color: #fff;
          .office-point {
            width: 659px;
            overflow: hidden;
            // animation: leftMove 10s ease-out infinite;
            li {
              float: left;
              width: 170px;
              height:34px;
              list-style: none;
              margin-right: 5px;
              img {
                height: 100%;
                width: 100%;
              }
            }
          }
        }
        &-trends {
          position: absolute;
          bottom: 0;
          right: 0;
          z-index: 9;
          .trends-item {
            position: absolute;
            list-style: none;
            width: 32px;
            height: 50px;
            background-repeat: no-repeat;
            &-1 {
              animation: trends 10s linear infinite;
            }
            &-2 {
              animation: trends 10s linear 2s infinite;
            }
            &-3 {
              animation: trends 10s linear 4s infinite;
            }
            &-4 {
              animation: trends 10s linear 6s infinite;
            }
            &-5 {
              animation: trends 10s linear 8s infinite;
            }
          }
        }
        &-shade {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
        }
      }
    }
  }
}
@keyframes trends {
  0% {
    bottom: 250px;
    right: 30px;
    opacity: 0;
    background-image: url("~img/blockChain/dapp_d_icon.png");
  }
  24% {
    bottom: 66px;
    right: 30px;
    opacity: 1;
    background-image: url("~img/blockChain/dapp_d_icon.png");
  }
  25% {
    bottom: 66px;
    right: 30px;
    opacity: 1;
    background-image: url("~img/blockChain/dapp_d_icon.png");
  }
  26% {
    bottom: 66px;
    right: 30px;
    opacity: 1;
    background-image: url("~img/blockChain/dapp_d_icon.png");
  }
  100% {
    bottom: 66px;
    right: 250px;
    opacity: 0;
    background-image: url("~img/blockChain/dapp_d_icon.png");
  }
}
@keyframes shown {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

// @media screen and (max-width: 1550px) {
  .networkState {
    width: 100%;
    height: 771px;
    margin-top: 50px;
    background-size: 100% 100%;
  }
  .networkState .container .network-title {
    position: absolute;
    left: 50%;
    top: 20px;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    width: 585px;
    height: 41px;
    line-height: 21px;
    text-align: center;
    font-size: 26px;
    background-size: 100% 100%;
    color: #fff;
  }
  .networkState .container .network-status {
    position: absolute;
    display: flex;
    top: 29px;
    right: 0;
  }
  .networkState .container .network-content {
    position: relative;
    top: 64px;
    left: 272px;
    width: 727px;
   height: 492px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .networkState .container .network-content .network-content-tips {
    position: absolute;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
//   .networkState .container .network-content .network-content-tips-0 {
//     right: 218px;
//     top: 180px !important;
//   }
//   .networkState .container .network-content .network-content-tips-1 {
//     right: 213px;
//     top: 180px !important;
//   }
//   .networkState .container .network-content .network-content-tips-2 {
//     right: 228px;
//     top: 154px;
//   }
//   .networkState .container .network-content .network-content-tips-3 {
//         right: 244px !important;
//     top: 166px !important;
//   }
//   .networkState .container .network-content .network-content-tips-4 {
//         right: 254px !important;
//     top: 182px !important;
    
//   }
//   .networkState .container .network-content .network-content-tips-5 {
//     right: 239px;
//     top: 396px !important;
//   }
//   .networkState .container .network-content .network-content-tips-6 {
//    top: 196px !important;
//     right: 240px !important;
//   }
//   .networkState .container .network-content .network-content-tips-7{
//         right: 200px !important;
//     top: 307px !important;
//   }
//   .networkState .container .network-content .network-content-tips-8{
//     right: 192px !important;
//     top: 309px !important;
//   }
//   .networkState .container .network-content .network-content-tips-9{
//    right: 252px !important;
//     top: 191px !important;
//   }
//   .networkState .container .network-content .network-content-tips-10 {
//     right: 258px !important;
//     top: 203px !important;
//   }
//   .networkState .container .network-content .network-content-tips-11 {
   
//     right: 274px !important;
//     top: 163px !important;
//   }
//   .networkState .container .network-content .network-content-tips-12{
//          right: 320px !important;
//     top: 182px !important;
//   }
//   .networkState .container .network-content .network-content-tips-13{
//         right: 193px !important;
//     top: 331px !important;
//   }
//   .networkState .container .network-content .network-content-tips-14 {
//      right: 279px !important;
//     top: 182px !important;
//   }
//   .networkState .container .network-content .network-content-tips-15{
//     right: 252px !important;
//     top: 200px !important;
//   }
//   .networkState .container .network-content .network-content-tips-16{
//     right: 271px !important;
//     top: 393px !important;
//   }
//   .networkState .container .network-content .network-content-tips-17{
//      right: 261px !important;
//     top: 182px !important;
//   }
//  .networkState .container .network-content .network-content-tips-18{
//    right: 265px !important;
//     top: 179px !important;
//   }
//    .networkState .container .network-content .network-content-tips-19{
//    right: 265px !important;
//     top: 191px !important;
//   }
// .networkState .container .network-content .network-content-tips-20{
//     right: 203px !important;
//     top: 359px !important;
//   }
//   .networkState .container .network-content .network-content-tips-21{
//     right: 286px !important;
//     top: 406px !important;
//   }
//   .networkState .container .network-content .network-content-tips-22{
//     right: 259px !important;
//     top: 395px !important;
//   }
//   .networkState .container .network-content .network-content-tips-23{
//     right: 238px !important;
//     top: 198px !important;
//   }
//   .networkState .container .network-content .network-content-tips-24{
//     right: 238px !important;
//     top: 205px !important;
//   }
//   .networkState .container .network-content .network-content-tips-25{
//     right: 386px !important;
//     top: 306px !important;
//   }
//   .networkState .container .network-content .network-content-tips-26{
//     right: 270px !important;
//     top: 398px !important;
//   }
//   .networkState .container .network-content .network-content-tips-27{
//     right: 290px !important;
//     top: 408px !important;
//   }
//   .networkState .container .network-content .network-content-tips-28{
//     right: 282px !important;
//     top: 382px !important;
//   }
  .networkState .container .network-nodes {
    position: absolute;
    left: 0;
    bottom: 54px;
    width: 100%;
    height: 164px;
  }
  .networkState .container .network-nodes-title {
    top: 8px;
    left: 526px;
  }
  .networkState .container .network-nodes-num {
    top: 52px;
    left: 44px;
  }
  .networkState .container .network-nodes-preview {
    top: 74px;
    left: 175px;
  }

  .networkState .container .network-nodes-trends {
    position: absolute;
    bottom: -7px;
    right: 0;
    z-index: 9;
  }
// }
</style>
